import styled from 'styled-components';
import { T0 } from 'ia-react-core';
// import informationIcon from '../../assets/ic-info-outline.svg';

export const StyledTitle = styled(T0)`
  text-align: center;

  @media only screen and (max-width: 600px)
  {
    font-size: 32px;
  }
`;

export const StyledInstabilityMessages = styled.div`
  max-width: 560px;
  margin: auto;
`;
